import { useParams } from "react-router";
import { HeaderBranding } from "@/features/layout/components/HeaderBranding";

/**
 * Página de videollamada con avatar (HeyGen/LiveKit).
 * Funcionalidad desactivada temporalmente para reducir consumo de CPU en dev.
 * Ver documentacion/PLAN_LIMPIAR_HEYGEN_LIVEKIT_SOCKETIO.md para reactivar.
 */
export default function VideoCallPage() {
  const { sessionId } = useParams<{ sessionId: string }>();

  return (
    <div className="flex h-screen flex-col">
      <HeaderBranding />
      <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col items-center justify-center gap-6 px-6 py-8">
        <section className="rounded-lg border border-slate-200 bg-white p-8 shadow-sm text-center max-w-md">
          <h1 className="text-xl font-semibold text-slate-800 mb-2">
            Sesión de retroalimentación
          </h1>
          {sessionId && (
            <p className="text-xs text-slate-500 mb-4">
              <span className="font-semibold">ID de sesión:</span> {sessionId}
            </p>
          )}
          <p className="text-sm text-amber-700 bg-amber-50 rounded px-4 py-3 border border-amber-200">
            Funcionalidad de videollamada desactivada temporalmente.
          </p>
          <p className="text-xs text-slate-500 mt-3">
            Para reactivarla, ver el plan en documentación del proyecto.
          </p>
        </section>
      </div>
    </div>
  );
}
